<style lang="scss">
  @import '../../../sass/variables';

  #modal-new-deal{
    @media (min-width: 576px) {
      #modal-new-deal {

        .modal-dialog {
          max-width: 500px;
          margin: 1.75rem auto;
        }
      }
    }

    @media (min-width: 992px) {
      #modal-new-deal {

        .modal-dialog {
          max-width: 800px;
          margin: 1.75rem auto;
        }
      }
    }

    @media (min-width: 1200px) {
      #modal-new-deal {

        .modal-dialog {
          max-width: 1140px;
          margin: 1.75rem auto;
        }
      }
    }

    #modal-new-deal___BV_modal_content_ {
      color: $salesflow-font-dark !important;
      font-family: "Montserrat" !important;
      font-size: 0.75rem !important;
      font-weight: 500 !important;
      letter-spacing: -0.21px;
      line-height: 150%;
      border-radius: 16px;
      overflow: hidden;

      .modal-header {
        background-color: $salesflow-primary;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 16px 24px;

        .modal-title {
          font-size: 12px;
          font-weight: 400;
        }
      }

      .modal-body,
      .modal-footer {
        background-color: $salesflow-bg-content !important;
        padding: 16px 24px 32px 24px;

        button {
          padding: 12px;
          border-radius: 14px;
          height: 50px;
          width: inherit;
          font-size: 16px;
          background-color: $salesflow-primary;
          color: $white;

          &:hover {
            background-color: $salesflow-primary-hover;
          }

        }

        input.multiselect__input {
          border: none;
          outline: none;
        }

        .multiselect__tags {
          padding: 0;
          display: flex;
          align-self: center;
          padding: 12px 14px;
          outline: 1px solid $salesflow-outline-gray-medium;
          background-color: $salesflow-bg-content;
          border-radius: 8px;

          span.multiselect__placeholder{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            color: $salesflow-outline-gray-medium;
            font-weight: 500;
            font-size: 1rem !important;
            line-height: 150%;
            background-color: $white;
          }
        }
      }

      .modal-body {
        .multiselect {
          border: 0;
          background: $salesflow-bg-content;
          border-radius: 8px;
          outline: 1px solid $salesflow-outline-gray-medium;

          input, select {
            padding: 12px 18px;
          }
        }

        input, select {

          &::placeholder {
            color: $salesflow-outline-gray-medium;
            font-weight: 500;
            font-size: 1rem !important;
          }

          options {
            font-size: 0.75rem !important;
          }


          padding: 12px 14px;
          color: $salesflow-font-dark;
          background-color: $white !important;
          outline: 1px solid $salesflow-outline-gray-medium;
          border-radius: 8px;
          font-weight: 400;
          font-size: 1rem;
          line-height: 150% !important;
        }

        select {
          font-size: 0.75rem !important;
        }

        input#search-lead {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background-color: $salesflow-bg-content;
          padding: 12px 18px;
        }

        label {
          font-weight: 500 !important;
          line-height: 150% !important;
          color: $salesflow-font-dark;
        }

        .mx-datepicker {
          input {
            font-size: 12px;
          }
        }
      }

      .input-group {
        background-color: $white;
        outline: 1px solid $salesflow-outline-gray-medium;
        border-radius: 8px;

        .input-group-text {
          background-color: transparent;
          padding: 0;
          border: 0;
          margin-left: 18px;
          margin-right: 12px;
        }

        input {
          padding: 12px 14px;
          background-color: transparent !important;
          outline: 0;
        }
      }



      li {

        span {
          color: #857a98;
        }
      }
    }
  }
</style>

<template>
  <BModal
    id="modal-new-deal"
    ref="modal-new-deal"
    hide-footer="hide-footer"
    modal-class="modal-width-500"
  >
    <template slot="modal-header">
      <div
        class="modal-title"
        v-if="lead.name"
      >
        {{ __('Novo negócio com') }} {{ lead.name | firstword }}
      </div>
      <div
        class="modal-title"
        v-else
      >
        {{ __('Novo Negócio') }}
      </div>
      <button
        class="close"
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        @click="hideModal()"
      >
        <span aria-hidden="true" ><img
          class="mb-1"
          src="/build/icons/close@white.svg"
          alt="Fechar"
          width="14"
          height="13"
        ></span>
      </button>
    </template>
    <template slot="default">
      <div v-if="loading">
        <i class="fa fa-circle-o-notch fa-spin" />
      </div>
      <div v-else>
        <form @submit.prevent="save">
          <div class="row">
            <div
              class="col-md-12"
              v-if="search"
            >
              <div
                class="form-group bdk-pb-2"
                :class="{ 'has-error': dealForm.errors.has('lead') }"
              >
                <label>Lead</label>
                <div class="search-lead">
                  <Multiselect
                    id="search-lead"
                    label="name"
                    track-by="hashid"
                    v-model="selectedLead"
                    :placeholder="__('Digite para pesquisar')"
                    :loading="searching"
                    :options="leads"
                    :multiple="false"
                    :searchable="true"
                    :show-labels="false"
                    :hide-selected="true"
                    :preserve-search="true"
                    :internal-search="false"
                    :show-no-options="false"
                    :show-no-results="false"
                    :custom-label="customLabel"
                    @select="selectLead"
                    @search-change="searchLead"
                  >
                    <template
                      slot="option"
                      slot-scope="props"
                    >
                      <div><span class="d-block">{{ props.option.name || props.option.email }}</span><small>{{ props.option.name ? props.option.email : null }}</small></div>
                    </template>
                  </Multiselect>
                </div><span
                  class="form-text"
                  v-show="dealForm.errors.has('lead')"
                >{{ dealForm.errors.get('lead') }}</span><i
                  class="fa fa-circle-o-notch fa-spin m-t-15"
                  v-if="searching"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group pb-3 mb-3">
                <label>{{ __('Título do negócio (opcional)') }}</label>
                <input
                  class="form-control"
                  id="new-deal-title"
                  type="text"
                  v-model="dealForm.title"
                >
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group pb-3 mb-3">
                <label>{{ __('Valor') }}</label>
                <div class="input-group">
                  <div class="input-group-text">
                    {{ __('R$') }}
                  </div>
                  <InputCurrency
                    class="form-control"
                    v-model="dealForm.value"
                    :placeholder="0"
                    required
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="pipelines.length"
            >
              <div
                class="form-group pb-3 mb-3"
                :class="{ 'has-error': dealForm.errors.has('stage_id') }"
              >
                <label>{{ __('Estágio do funil') }}</label>
                <Multiselect
                  label="name"
                  track-by="id"
                  v-model="stage"
                  group-label="name"
                  :options="pipelines"
                  :group-values="'stages'"
                  :multiple="multiselect.multiple"
                  :show-labels="multiselect.showLabel"
                  :group-select="multiselect.groupSelect"
                  :placeholder="__(multiselect.placeholder)"
                /><span
                  class="form-text"
                  v-show="dealForm.errors.has('stage_id')"
                >{{ dealForm.errors.get('stage_id') }}</span>
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="users.length"
            >
              <div
                class="form-group pb-3 mb-3"
                :class="{ 'has-error': dealForm.errors.has('user_id') }"
              >
                <label>{{ __('Dono do negócio') }}</label>
                <select
                  class="form-control"
                  v-model="dealForm.user_id"
                >
                  <option value="">
                    {{ __('Selecione') }}
                  </option>
                  <option
                    v-for="user in users"
                    :value="user.id"
                    :key="user.id"
                  >
                    {{ user.name }}
                  </option>
                </select><span
                  class="form-text"
                  v-show="dealForm.errors.has('user_id')"
                >{{ dealForm.errors.get('user_id') }}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group pb-3 mb-3">
                <label>{{ __('Status de probabilidade') }}</label>
                <select class="form-control" v-model="dealForm.temperature">
                  <option value="">
                    {{ __('Selecione') }}
                  </option>
                  <option value="hot" >{{ __('Quente')}}</option>
                  <option value="warm" >{{ __('Morno')}}</option>
                  <option value="cold" >{{ __('Frio')}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="form-group bdk-pb-8"
                :class="{ 'has-error': dealForm.errors.has('expected_at') }"
              >
                <label>{{ __('Fechamento esperado') }}</label>
                <InputDateTimepicker v-model="dealForm.expected_at" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row mx-auto">
                <div class="col-6">
                  <BButton
                    id="save-and-view"
                    class="float-right"
                    variant="purple"
                    type="submit"
                    :disabled="dealForm.busy"
                    @click="saveAndShow = true"
                  >
                    <span v-if="dealForm.busy && saveAndShow"><i class="fa fa-circle-o-notch fa-spin" /></span><span class='text-nowrap' v-else>{{ __('Salvar e visualizar') }}</span>
                  </BButton>
                </div>
                <div class="col-6">
                  <BButton
                  id="save-and-close"
                    variant="primary"
                    type="submit"
                    :disabled="dealForm.busy"
                    @click="saveAndShow = false"
                  >
                    <span v-if="dealForm.busy && ! saveAndShow"><i class="fa fa-circle-o-notch fa-spin" /></span><span class='text-nowrap' v-else>{{ __('Salvar e fechar') }}</span>
                  </BButton>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>
  </BModal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';

function addDealForm (base) {
  return {
    lead: base ? base.lead.hashid : null,
    title: base ? base.title : null,
    value: base ? base.value : 0,
    stage_id: '',
    user_id: base && base.user_id ? base.user_id : '',
    expected_at: new Date(),
    temperature: '',
    saveAndShow: true,
    newDeal: null
  };
}

export default {
  components: {
    BModal,
    BButton,
  },

  created () {
    this.getPipelines();
  },

  watch: {
    stage (stage) {
      if (stage == null) {
        return;
      }

      this.dealForm.stage_id = stage.id;

      if (this.dealForm.errors.has('stage_id')) {
        delete this.dealForm.errors.errors.stage_id;
      }
    },
  },

  store: ['users'],

  mounted () {
    this.loading = false;

    Bus.$on('leadRetrieved', (lead) => {
      this.lead = lead;
      this.dealForm.lead = lead.hashid;
    });

    Bus.$on('pipelinesRetrieved', (pipelines) => {
      const stages = [];

      for (let i = 0; i < pipelines.length; i++) {
        for (let j = 0; j < pipelines[i].stages.length; j++) {
          const stage = {
            id: pipelines[i].stages[j].id,
            name: `${pipelines[i].name}: ${pipelines[i].stages[j].name}`,
          };

          stages.push(stage);
        }
      }

      Bus.$emit('stagesRetrieved', stages);
    });

    Bus.$on('createDealButtonToggled', (payload) => {
      if (payload == null) {
        this.dealForm.newDeal = true;
      }

      if (payload != null) {
        this.dealForm.newDeal = false;
        this.search = false;
      }

      const lead = Array.isArray(payload)
        ? payload[0]
        : payload;

      if (lead && typeof payload[1] === 'object') {
        this.dealForm = new BulldeskForm(addDealForm(payload[1]));
      }

      if (lead) {
        this.lead = lead;
        this.dealForm.lead = lead.hashid;
      } else {
        this.search = true;
      }

      this.open();
    });
  },

  data () {
    return {
      lead: {},
      leads: [],
      stage: '',
      pipelines: [],
      search: false,
      loading: true,
      searching: false,
      selectedLead: null,
      multiselect: {
        multiple: false,
        showLabel: false,
        placeholder: 'Selecione',
        noResult: 'Nenhuma opção encontrada',
        groupSelect: false,
      },
      dealForm: new BulldeskForm(addDealForm()),
    };
  },

  methods: {
    getPipelines () {
      this.loading = true;

      this.$http.get('/pipeline')
        .then((response) => {
          this.pipelines = response.data.pipelines;
          this.loading = false;

          Bus.$emit('pipelinesRetrieved', this.pipelines);
        });
    },

    open () {
      this.$refs['modal-new-deal'].show();

      setTimeout(() => {
        const el = document.getElementById('new-deal-title');

        if (this.dealForm.lead && el) {
          el.focus();
        }
      }, 1000);
    },

    customLabel ({ name, email }) {
      return name || email;
    },

    selectLead (lead) {
      this.setLead(lead.hashid, lead.name);

      if (this.dealForm.errors.has('lead')) {
        delete this.dealForm.errors.errors.lead;
      }
    },

    setLead (hashid, name) {
      this.dealForm.lead = hashid;
      this.lead = { ...this.lead, hashid, name };
    },

    searchLead (query) {
      if (query.length < 3) {
        return;
      }

      this.searching = true;

      this.$http.get(`/lead/search?query=${query}`)
        .then((response) => {
          this.leads = response.data;
        })
        .finally(() => {
          this.searching = false;
        });
    },

    save () {
      Http.post('/deal', this.dealForm)
        .then((data) => {
          Bus.$emit('dealCreated', {
            card: data,
            column: data.stage_id,
          });

          this.hideModal();
          this.cleanModal();

          Alert.success(this.__('Negócio criado com sucesso!'));

          if (this.saveAndShow) {
            window.location = `/deal#/${data.hashid}`;
          }
        })
        .catch(() => {});
    },

    hideModal () {
      this.$refs['modal-new-deal'].hide();
    },

    cleanModal () {
      this.dealForm.lead = '';
      this.dealForm.title = '';
      this.dealForm.value = 0;
      this.dealForm.stage_id = '';
      this.dealForm.temperature = '';
      this.stage = null;
      this.dealForm.user_id = '';
      this.dealForm.expected_at = new Date();
      if (this.dealForm.newDeal) {
        this.selectedLead = null;
        this.lead.name = '';
        this.lead.hashid = '';
      }
    },
  },
};
</script>
